export const LIST_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST =
  'LIST_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST'
export const LIST_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS =
  'LIST_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS'
export const LIST_MCU_PROJECT_PERIOD_CUT_OFF_FAIL =
  'LIST_MCU_PROJECT_PERIOD_CUT_OFF_FAIL'

export const DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST =
  'DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST'
export const DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS =
  'DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS'
export const DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_FAIL =
  'DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_FAIL'

export const CREATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST =
  'CREATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST'
export const CREATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS =
  'CREATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS'
export const CREATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL =
  'CREATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL'

export const UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST =
  'UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST'
export const UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS =
  'UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS'
export const UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL =
  'UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL'

export const DELETE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST =
  'DELETE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST'
export const DELETE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS =
  'DELETE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS'
export const DELETE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL =
  'DELETE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL'
